module.exports = __webpack_public_path__ + "img/DNADamage-LUCA_10X_LU.ebb06fc3.png";